export const prioritizedCurrencies = ['NOK', 'SEK', 'DKK', 'EUR', 'USD']

export const currencyToOption = currency => ({
    value: currency,
    text: currency,
    key: currency
})